export default "__VITE_ASSET__Bw7cf3oX__"